import { create } from 'zustand';
import { SORT_OPTIONS } from './SortOptions';

/**
 * 정렬 상태 관리를 위한 Zustand 스토어
 * 정렬 상태를 중앙에서 관리하고 컴포넌트 간 동기화를 제공
 */
const useSortStore = create((set) => ({
  // 현재 선택된 정렬 옵션
  selectedSort: SORT_OPTIONS.POPULAR.code,
  
  // 정렬 옵션 변경 함수
  setSort: (sortCode) => {
    set({ selectedSort: sortCode });
  },
  
  // 초기 정렬 옵션 설정 함수
  initializeSort: (initialSort) => {
    // 유효한 정렬 옵션인지 확인
    const isValidSort = Object.values(SORT_OPTIONS).some(option => option.code === initialSort);
    set({ selectedSort: isValidSort ? initialSort : SORT_OPTIONS.POPULAR.code });
  }
}));

export default useSortStore;
